module.exports = __webpack_public_path__ + "media/16 Party’s Day.a812f551.mp3";